<button
  [class]="'text-button-' + type + ' text-button-' + size + '-size'"
  [disabled]="disabled"
  type="button"
  (click)="buttonClicked.emit()">
  <ng-content></ng-content>
</button>
